import { render, staticRenderFns } from "./SubjectHeader.vue?vue&type=template&id=636e36b4&scoped=true&"
import script from "./SubjectHeader.ts?vue&type=script&lang=ts&"
export * from "./SubjectHeader.ts?vue&type=script&lang=ts&"
import style0 from "./subject-header.scss?vue&type=style&index=0&id=636e36b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636e36b4",
  null
  
)

export default component.exports